import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

// Legacy route — Google OAuth via the local backend is no longer wired up.
// We surface a friendly message and route the visitor back to sign-in.
export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    toast.info("Please sign in with your email and password.");
    navigate("/sign-in", { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center text-gray-400">
      <Loader2 className="animate-spin mr-2" size={20} /> Redirecting…
    </div>
  );
}
